// src/views/auth/signUp/SignUpPage.jsx
import React, { useState } from "react";
import { Box, Flex, Text, AspectRatio, Image, useBreakpointValue } from "@chakra-ui/react";
import SignUp from "./index";

const heroTitleLines = ["회원가입으로", "예상공사비를 예측하세요😃"];
const heroSubtitle = "공사 개요를 입력하면 AI가 예상 공사비를 산출해드립니다.";

export default function SignUpPage() {
  const heroTitleFontSize = useBreakpointValue({ base: "28px", md: "32px", lg: "36px" });
  const [heroLoaded, setHeroLoaded] = useState(false);

  return (
    <Box minH="100vh" bgGradient="linear(to-b, #eef2ff, #fefefe)" px={{ base: 4, md: 6 }}>
      <Flex minH="100vh" align="center" justify="center" py={{ base: 6, md: 10 }}>
        <Box w="full" maxW="1024px">
          <Box
            bg="white"
            borderRadius={{ base: "24px", md: "32px" }}
            borderWidth="1px"
            borderColor="rgba(15, 23, 42, 0.08)"
            boxShadow="0 40px 90px rgba(15, 23, 42, 0.18)"
            overflow="hidden"
          >
            <Flex
              direction={{ base: "column", lg: "row" }}
              gap={{ base: 0, lg: 1 }}
              align="stretch"
            >
              <Box
                flex={{ base: "none", lg: 1 }}
                display="flex"
                p={{ base: 8, lg: 10 }}
                bg="white"
                borderRight={{ base: "none", lg: "1px solid rgba(15, 23, 42, 0.08)" }}
              >
                <Box w="100%">
                  <Text
                    fontSize={heroTitleFontSize}
                    fontWeight="700"
                    lineHeight="1.2"
                    color="#0f172a"
                  >
                    {heroTitleLines.map((line) => (
                      <Text as="span" key={line} display="block">
                        {line}
                      </Text>
                    ))}
                  </Text>
                  <Text mt={2} fontSize={{ base: "13px", md: "13px" }} color="gray.600">
                    {heroSubtitle}
                  </Text>
                  <Box
                    mt={6}
                    borderRadius="28px"
                    overflow="hidden"
                    bg="gray.50"
                    boxShadow="0 25px 50px rgba(37, 99, 235, 0.25)"
                  >
                    <AspectRatio ratio={4 / 3}>
                      <Image
                        src="/starter.gif"
                        alt="프로젝트 스타터"
                        objectFit="cover"
                        opacity={heroLoaded ? 1 : 0}
                        transition="opacity 0.7s ease"
                        onLoad={() => setHeroLoaded(true)}
                        draggable={false}
                      />
                    </AspectRatio>
                  </Box>
                </Box>
              </Box>

              <Box
                flex={{ base: "none", lg: 1 }}
                p={{ base: 8, md: 10 }}
                bg="white"
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
              >
                <SignUp />
              </Box>
            </Flex>
          </Box>
          <Text mt={6} fontSize="12px" color="gray.400" textAlign="center">
            © XI S&D, All Rights Reserved. Designed & Developed by DX Team.
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
